import { render, staticRenderFns } from "./EventOrderMedia.vue?vue&type=template&id=48e1b306&scoped=true"
import script from "./EventOrderMedia.vue?vue&type=script&lang=js"
export * from "./EventOrderMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1b306",
  null
  
)

export default component.exports